import React from "react";
import { useHistory } from "react-router-dom";
import { navTo } from "@origin-digital/event-dispatcher";
import { Divider } from "@origin-digital/ods-core";
import { pageRoutes } from "../../consts";
import { useJointAccountHolderAccess } from "../../context/JointAccountHolder/JointAccountHolderAccess";

import { Description, DescriptionList } from "../../components/DescriptionList";
import { formatDob } from "../../utils/helpers";
import { FieldType, ProfileFieldMap } from "../../crm/profileFieldMap";
import { getLinkText } from "./ManageScreen";
import content from "./content.json";

export interface IPersonalDetailProps {
  fieldMap: Pick<ProfileFieldMap, FieldType.DOB | FieldType.NAME>;
  callNavTo: (
    navToEvent: () => Promise<Record<string, unknown>>
  ) => () => Promise<void>;
}

export const PersonalDetail: React.FC<IPersonalDetailProps> = ({
  fieldMap,
  callNavTo,
}) => {
  const history = useHistory();
  const { eligible } = useJointAccountHolderAccess();
  const name = fieldMap.NAME;
  const dob = fieldMap.DOB;
  const [updateName] = name?.useUpdate?.() || [];
  return (
    <DescriptionList
      data-id="personal-details"
      heading={content.personal.heading}
    >
      {name && (
        <Description
          data-id="name"
          label={content.personal.name}
          value={name.data ?? ""}
          linkText={
            name.editable && name.useUpdate ? content.links.change : undefined
          }
          onClick={() => updateName?.("name")}
        />
      )}
      <Divider />
      {eligible && (
        <Description
          data-id="joint-account-holder"
          actionId="add-joint-account-holder"
          label="Joint account holder"
          value=""
          linkText="Add"
          onClick={() => history.push(pageRoutes.jointAccountHolder)}
        />
      )}
      {eligible && <Divider />}
      {dob && (
        <Description
          data-id="dob"
          label={content.personal.dob}
          value={dob.data ? formatDob(dob.data) : ""}
          linkText={
            dob.editable && dob.useUpdate ? getLinkText(dob.data) : undefined
          }
          onClick={callNavTo(navTo.profileDob)}
        />
      )}
      <Divider />
    </DescriptionList>
  );
};
